// list of documents in the Help Center
export const helpDocs = {
	operatorGuides: [
		{
			name: 'Adjusting EcoCounts',
			route: 'adjusting-ecocounts',
			path: '/static/guides/kiosk/adjusting-ecocounts.md',
		},
		{
			name: 'Standard Kiosk Mode',
			route: 'standard-kiosk-mode',
			path: '/static/guides/kiosk/standard-kiosk-mode.md',
		},
		{
			name: 'Payment Preference',
			route: 'payment-preference',
			path: '/static/guides/kiosk/payment-preference.md',
		},
		{
			name: 'Admin and Machine Setup',
			route: 'admin-setup',
			path: '/static/guides/kiosk/admin-setup.md',
		},
		{
			name: 'EcoCard Setup',
			route: 'ecocard-setup',
			path: '/static/guides/kiosk/ecocard-setup.md',
		},
		{
			name: 'User Sign Up',
			route: 'sign-up',
			path: '/static/guides/kiosk/sign-up.md',
		},
		{
			name: 'Express Mode',
			route: 'express-mode',
			path: '/static/guides/kiosk/express-mode.md',
		},
		{
			name: 'CA Transactions Over $100',
			route: 'ca-transactions-over-100',
			path: '/static/guides/kiosk/ca-transactions-over-100.md',
		},
		{
			name: 'Cash Payouts',
			route: 'cash-payouts',
			path: '/static/guides/kiosk/cash-payouts.md',
		},
	],
};
